(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6943],{

/***/ 30190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94964);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71723);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48379);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var PRESS_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__.find(function (i) {
  return i.name === "datamynt-polygon";
});

function DataMyntPolygon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_5__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        item: PRESS_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "font-semibold text-lg",
          children: "The investment & integration streamlines adoption of Data Mynt\u2019s stable crypto checkout and payment protocol globally on the Polygon network for merchants and metaverse builders alike."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Oakland, CA (July 5, 2022) - Today, decentralized commerce, stable crypto checkout & payment protocol Data Mynt announced a strategic investment from Polygon. The two parties will focus on lowering the entry barriers of entry and mass adoption of decentralized commerce, stable crypto checkout and payments that improves on existing payment experiences for consumers and merchants."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "In February, Data Mynt successfully integrated with Polygon. The integration aimed to improve crypto checkout and payments experience in person via Data Mynt mobile Point of Sale app and online globally."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "In the near future, Data Mynt will bring its native token to Polygon."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "In addition to Polygon, Data Mynt supports Ethereum Mainnet, Bitcoin, Lightnin Network, and Binance Smart Chain (BNB)."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "Alex Christian, Data Mynt CEO, marks this strategic investment from the industry giant as \u201CThis is the next step of a partnership between two teams united in the belief that better decentralized commerce and payments options accessible to every merchant and metaverse builder is a necessity.\u201D"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Polygon joins previous Data Mynt investors including Coinbase Ventures, Startup Haven Ventures, and AngelList."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Click", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://datamynt.com/contactus",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "here"
            })
          }), " ", "to learn more about Data Mynt\u2019s stable crypto checkout and payment protocol."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is the leading stable decentralized commerce, payment and checkout protocol. It offers partners and merchants an omnichannel approach to accepting crypto payments from any wallet free from crypto volatility and the risks and costs of traditional payment methods. The Data Mynt crypto checkout payment solution is designed to streamline implementation via mobile Point of Sale, API, branded web page, and iFrame, while consistently delivering a seamless customer experience for over 100 merchants globally."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: "flex space-x-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://datamynt.com",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://twitter.com/DataMynt",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Twitter"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://www.linkedin.com/company/datamynt/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "LinkedIn"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About Polygon"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Polygon is the leading platform for Ethereum scaling and infrastructure development. Its growing suite of products offers developers easy access to all major scaling and infrastructure solutions: L2 solutions (ZK Rollups and Optimistic Rollups), sidechains, hybrid solutions, stand-alone and enterprise chains, data availability solutions, and more. Polygon's scaling solutions have seen widespread adoption with 3000+ applications hosted, 1B+ total transactions processed, ~100M+ unique user addresses, and $5B+ in assets secured."
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (DataMyntPolygon);

/***/ }),

/***/ 38074:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/datamynt-polygon",
      function () {
        return __webpack_require__(30190);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(38074); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);